import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import HeroSectionNew from '../components/HeroSectionNew';
import SignatureOrigin from '../components/SignatureOrigin';
import ThreeTypes from '../components/ThreeTypes';
import CelebrityCases from '../components/CelebrityCases';
import CommonMistakesNew from '../components/CommonMistakesNew';
import BeforeAfterNew from '../components/BeforeAfterNew';
import TestimonialsNew from '../components/TestimonialsNew';
import AboutStevenNew from '../components/AboutStevenNew';
import FooterNew from '../components/FooterNew';
import RegistrationModal from '../components/RegistrationModal';
import { useTrackingPixel } from '../hooks/use-tracking-pixel';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [webinarSettings, setWebinarSettings] = useState({ date: '', time: '' });
  const [searchParams] = useSearchParams();

  const utmData = {
    utm_source: searchParams.get('utm_source') || '',
    utm_medium: searchParams.get('utm_medium') || '',
    utm_campaign: searchParams.get('utm_campaign') || '',
    utm_term: searchParams.get('utm_term') || ''
  };

  useEffect(() => {
    fetch(`${API_URL}/api/settings`)
      .then(r => r.json())
      .then(data => setWebinarSettings(data))
      .catch(() => setWebinarSettings({ date: '19th March 2026 (Thursday)', time: '8.00PM (Singapore Time)' }));
  }, []);

  useTrackingPixel(webinarSettings.tracking_pixel);

  const handleRegisterClick = () => setIsModalOpen(true);

  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <Navbar onRegisterClick={handleRegisterClick} />
      <HeroSectionNew onRegisterClick={handleRegisterClick} settings={webinarSettings} />
      <SignatureOrigin onRegisterClick={handleRegisterClick} />
      <ThreeTypes />
      <CelebrityCases />
      <CommonMistakesNew />
      <BeforeAfterNew onRegisterClick={handleRegisterClick} settings={webinarSettings} />
      <TestimonialsNew />
      <AboutStevenNew onRegisterClick={handleRegisterClick} />
      <FooterNew />
      <RegistrationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        settings={webinarSettings}
        utmData={utmData}
      />
    </div>
  );
};

export default Home;
